// Centralised, easily-editable content for CEMTEX.
// Swap image URLs or copy here without touching component code.

export const CONTACT = {
  phone: "0436 376 922",
  phoneHref: "tel:+61436376922",
  email: "admin@cemtex.com.au",
  location: "Perth, Western Australia",
  hours: "Available Mon–Fri, 7am–4pm",
  instagram: "https://www.instagram.com/cemtex.wa",
  instagramHandle: "@cemtex.wa",
};

export const IMAGES = {
  heroPlaster: "https://images.unsplash.com/photo-1581783748410-2c5377ad72ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  concreteStairs: "https://images.unsplash.com/photo-1520529890308-f503006340b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  plasterTexture: "https://images.pexels.com/photos/7941435/pexels-photo-7941435.jpeg?auto=compress&cs=tinysrgb&w=1600",
  concreteTexture: "https://images.pexels.com/photos/20364176/pexels-photo-20364176.jpeg?auto=compress&cs=tinysrgb&w=1600",
  bathroomStone: "https://images.unsplash.com/photo-1642755623141-23b3cb4284aa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  bathroomArch: "https://images.unsplash.com/photo-1722247481241-a57e9a50fb5f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  bathtub: "https://images.unsplash.com/photo-1721825156439-b21d374968de?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  houseWhite: "https://images.unsplash.com/photo-1523217582562-09d0def993a6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  houseBlue: "https://images.unsplash.com/photo-1628012209120-d9db7abf7eab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  houseUrban: "https://images.pexels.com/photos/32666364/pexels-photo-32666364.jpeg?auto=compress&cs=tinysrgb&w=1600",
  houseGeo: "https://images.pexels.com/photos/15422346/pexels-photo-15422346.jpeg?auto=compress&cs=tinysrgb&w=1600",
  interiorLight: "https://images.unsplash.com/photo-1651342490124-c2042b78d41c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  interiorHall: "https://images.unsplash.com/photo-1651342489820-7d824299445e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  interiorStair2: "https://images.unsplash.com/photo-1651342490186-7d3288f567e5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  kitchenWood: "https://images.unsplash.com/photo-1666003449012-61951d621555?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  kitchenMarble: "https://images.unsplash.com/photo-1611095210561-67f0832b1ca3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  kitchenLux: "https://images.unsplash.com/photo-1671197244266-73129c97c096?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  commercialGym: "https://images.unsplash.com/photo-1767531309781-b61fe1edfe86?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  commercialLobby: "https://images.unsplash.com/photo-1761971974992-6df33df97c3a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  commercialDark: "https://images.unsplash.com/photo-1697490551045-3414a6d998d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  wallDetail: "https://images.unsplash.com/photo-1611300731086-721a98b52e80?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  livingConcrete: "https://images.unsplash.com/photo-1696570398524-28566228df48?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  minimalHouse: "https://images.pexels.com/photos/13203188/pexels-photo-13203188.jpeg?auto=compress&cs=tinysrgb&w=1600",
};

export const SERVICES = [
  {
    slug: "microcement",
    index: "01",
    title: "Microcement",
    tagline: "Seamless. Continuous. Refined.",
    short: "A continuous, jointless surface system applied at 2–3mm. A refined finish for floors, walls, and wet areas.",
    hero: IMAGES.bathroomStone,
    intro:
      "Microcement is a hand-applied, jointless coating that wraps floors, walls and wet areas in a single continuous surface. Just 2–3mm thick, it transforms existing substrates without demolition — delivering a tactile, monolithic finish favoured in the world's most considered interiors.",
    specs: [
      { label: "Thickness", value: "2–3 mm" },
      { label: "Joints", value: "None — fully seamless" },
      { label: "Substrate", value: "Tile, concrete, screed" },
      { label: "Finish", value: "Matte to satin" },
    ],
    applications: ["Bathroom floors & walls", "Kitchen benchtops & splashbacks", "Living floors", "Feature walls", "Staircases", "Commercial retail"],
    benefits: [
      { title: "Waterproof by design", body: "Sealed to a fully water-resistant membrane — ideal for showers, wet rooms and pool surrounds." },
      { title: "No demolition", body: "Applied directly over existing tile and concrete, reducing mess, cost and downtime." },
      { title: "Monolithic beauty", body: "A continuous surface with no grout lines — light moves across it like polished stone." },
    ],
    gallery: [IMAGES.bathroomArch, IMAGES.livingConcrete, IMAGES.bathtub, IMAGES.interiorLight],
  },
  {
    slug: "rendering",
    index: "02",
    title: "Rendering",
    tagline: "Refined. Resilient. Architectural.",
    short: "Precision acrylic and cement rendering that redefines the street presence of any home or facade.",
    hero: IMAGES.houseWhite,
    intro:
      "Our rendering transforms brick, block and concrete into crisp, contemporary facades. From smooth acrylic systems to textured cement finishes, every render is floated to an exacting flatness that reads as architecture — not maintenance.",
    specs: [
      { label: "Systems", value: "Acrylic / cement" },
      { label: "Coats", value: "Base + finish" },
      { label: "Substrate", value: "Brick, block, AAC" },
      { label: "Finish", value: "Smooth / textured" },
    ],
    applications: ["Home exteriors", "Feature facades", "Fences & piers", "Commercial buildings", "Heritage restoration", "Rendered interiors"],
    benefits: [
      { title: "Instant street presence", body: "A rendered facade lifts kerb appeal and property value in a matter of days." },
      { title: "Weather resistant", body: "Flexible acrylic systems resist cracking, moisture and Perth's climate extremes." },
      { title: "Immaculate flatness", body: "Floated and finished by hand to a precise plane worthy of modern architecture." },
    ],
    gallery: [IMAGES.houseBlue, IMAGES.houseUrban, IMAGES.houseGeo, IMAGES.minimalHouse],
  },
  {
    slug: "plastering",
    index: "03",
    title: "Plastering",
    tagline: "Crafted. Luminous. Timeless.",
    short: "Solid and set plastering plus Venetian and decorative finishes with depth that shifts with the light.",
    hero: IMAGES.plasterTexture,
    intro:
      "From flawless set plaster to hand-burnished Venetian feature walls, our plastering is an exercise in craftsmanship. We build depth in layers — polished lime, marble dust and pigment — creating surfaces that change completely as the light moves through a room.",
    specs: [
      { label: "Types", value: "Set / solid / Venetian" },
      { label: "Layers", value: "Up to 5 coats" },
      { label: "Sheen", value: "Matte to high-polish" },
      { label: "Pigments", value: "Bespoke tint" },
    ],
    applications: ["Feature walls", "Ceilings & cornices", "Venetian polished plaster", "Full-home set plaster", "Archways & curves", "Commercial interiors"],
    benefits: [
      { title: "Extraordinary depth", body: "Layered lime and marble finishes carry a luminosity no paint can replicate." },
      { title: "Seamless walls", body: "Set plastering delivers a dead-flat surface ready for the most demanding lighting." },
      { title: "Bespoke by hand", body: "Every wall is trowelled individually — a one-of-a-kind artisan finish." },
    ],
    gallery: [IMAGES.wallDetail, IMAGES.concreteTexture, IMAGES.interiorHall, IMAGES.kitchenMarble],
  },
  {
    slug: "waterproofing",
    index: "04",
    title: "Waterproofing",
    tagline: "Protected. Guaranteed. Invisible.",
    short: "Certified waterproofing for wet areas, balconies and below-ground — the invisible layer that protects everything.",
    hero: IMAGES.concreteTexture,
    intro:
      "Waterproofing is the discipline that protects every other. Our certified applicators install compliant membrane systems across wet areas, balconies, planters and below-ground structures — engineered detailing that stays invisible for the life of the build.",
    specs: [
      { label: "Standard", value: "AS 3740 compliant" },
      { label: "Systems", value: "Liquid & sheet membrane" },
      { label: "Areas", value: "Internal & external" },
      { label: "Warranty", value: "Workmanship backed" },
    ],
    applications: ["Bathrooms & ensuites", "Balconies & terraces", "Planter boxes", "Basements & retaining", "Podiums & roof decks", "Commercial wet areas"],
    benefits: [
      { title: "Code compliant", body: "Every system installed to AS 3740 and manufacturer specification, fully documented." },
      { title: "Detailing that lasts", body: "Junctions, penetrations and fillets treated with engineered precision." },
      { title: "Peace of mind", body: "Workmanship-backed protection against the most costly failure in any build." },
    ],
    gallery: [IMAGES.bathtub, IMAGES.bathroomStone, IMAGES.wallDetail, IMAGES.interiorStair2],
  },
];

// Remediation groups the specialist repair disciplines from the brief.
export const REMEDIATION = {
  slug: "remediation",
  index: "05",
  title: "Remediation",
  tagline: "Restored. Reinforced. Resolved.",
  short: "Specialist structural remediation — concrete repairs, crack injection and rising damp treatment.",
  hero: IMAGES.wallDetail,
  intro:
    "When a structure needs more than a finish, our remediation division steps in. We diagnose, treat and restore — from spalling concrete and structural cracks to persistent rising damp — returning surfaces to full integrity before any finish is applied.",
  disciplines: [
    { name: "Concrete Repairs", tagline: "Restored. Reinforced. Resilient.", body: "Repair of spalling, cracking and exposed reinforcement using structural mortars and corrosion treatment." },
    { name: "Crack Injection", tagline: "Sealed. Structural. Permanent.", body: "Epoxy and polyurethane resin injection that bonds and seals structural cracks against water and movement." },
    { name: "Rising Damp Treatment", tagline: "Diagnosed. Treated. Protected.", body: "Diagnosis and treatment of rising damp with chemical damp-proof courses and salt-resistant re-rendering." },
  ],
  gallery: [IMAGES.concreteTexture, IMAGES.wallDetail, IMAGES.plasterTexture],
};

export const TRUST_SIGNALS = [
  { icon: "ShieldCheck", label: "Licensed & Insured" },
  { icon: "Building2", label: "Residential & Commercial" },
  { icon: "MapPin", label: "Perth Metro & Regional WA" },
  { icon: "FileText", label: "Free Quotes" },
  { icon: "BadgeCheck", label: "Quality Guarantee" },
];

export const SERVICE_TYPES = [
  "Waterproofing",
  "Concrete Repairs",
  "Crack Injection",
  "Rising Damp Treatment",
  "Rendering",
  "Plastering",
  "Microcement",
  "Other",
];

export const SERVICE_AREAS = [
  "Perth Metro", "Fremantle", "Joondalup", "Rockingham", "Mandurah",
  "Canning Vale", "Midland", "Baldivis", "Ellenbrook", "Armadale",
  "Bunbury", "Busselton", "Margaret River", "Geraldton", "Albany", "Regional WA",
];

export const TESTIMONIALS = [
  {
    quote: "CEMTEX transformed our bathroom completely. The microcement finish is unlike anything we have seen in Perth — it feels like we are living in a magazine. Absolutely flawless execution.",
    name: "James & Sarah W.",
    location: "Dalkeith, Perth",
    service: "Microcement",
  },
  {
    quote: "The team rendered our entire home exterior in three days. The finish is immaculate and the street presence has completely changed. Every neighbour stops to ask who did it.",
    name: "Marcus P.",
    location: "South Perth",
    service: "Rendering",
  },
  {
    quote: "We asked for a Venetian plaster feature wall and what we received exceeded every expectation. The depth of the finish is extraordinary — it changes completely with the light.",
    name: "Annabelle K.",
    location: "Claremont, Perth",
    service: "Plastering",
  },
  {
    quote: "Our basement had a chronic damp problem for years. CEMTEX diagnosed it properly, treated the rising damp and re-rendered the walls. Bone dry twelve months on.",
    name: "David & Lena T.",
    location: "Mount Lawley, Perth",
    service: "Remediation",
  },
  {
    quote: "As an interior designer I hold my trades to a very high standard. CEMTEX is the only surface team I now specify. Reliable, precise and genuinely craftsmen.",
    name: "Priya N.",
    location: "Cottesloe, Perth",
    service: "Plastering",
  },
  {
    quote: "The waterproofing and microcement on our commercial fit-out was completed on time and passed every inspection. A pleasure to have on site.",
    name: "Reuben M.",
    location: "Perth CBD",
    service: "Commercial",
  },
];

// Real CEMTEX project photos (sourced from cemtex.com.au). Swap/add freely.
const wixMedia = (id, h) => `https://static.wixstatic.com/media/${id}/v1/fill/w_1000,h_${h},al_c,q_90,usm_0.66_1.00_0.01,enc_auto/${id}`;
export const WIX = {
  p1: wixMedia("2f6e9a_b52b9708d4ad4bf3acd026d08ce5383d~mv2.jpeg", 1230),
  p2: wixMedia("2f6e9a_c32b315f3b994aeeb53b639365ed55b8~mv2.jpeg", 1236),
  p3: wixMedia("2f6e9a_f9f2eea04734436e8cbff13ba8c343fa~mv2.jpeg", 1240),
  p4: wixMedia("2f6e9a_d26878c649b0485f801aef6737c8db6d~mv2.jpeg", 1238),
  p5: wixMedia("2f6e9a_3f8691b73d104e1aa1947def5ea43bad~mv2.jpeg", 1250),
  p6: wixMedia("2f6e9a_6131bc39596b4ace82555fd2408d0879~mv2.jpeg", 1778),
  p7: wixMedia("2f6e9a_f3ba28a1dae14cf8a5c5534d041096e8~mv2.jpg", 1236),
  p8: wixMedia("2f6e9a_c8ba0a3b3e3a426a90a4cae0cd2566a7~mv2.jpeg", 1245),
  p9: wixMedia("2f6e9a_4666d654f0da4dc7aabbab140b7978c1~mv2.jpeg", 1243),
  p10: wixMedia("2f6e9a_a8a9f35cdd7942e29a42817a67c2e3fd~mv2.jpeg", 1243),
  p11: wixMedia("2f6e9a_8ea05a74d2e24940984ce6c6ecbf4a3c~mv2.jpeg", 960),
  p12: wixMedia("2f6e9a_b529c6b0eb574343abcf37bc8bf8efa8~mv2.jpeg", 960),
};

// Portfolio — edit freely. category: 'residential' | 'commercial'
export const PROJECTS = [
  { id: "warm-microcement-ensuite", title: "Warm Microcement Ensuite", category: "residential", finish: "Microcement", location: "Perth, WA", image: WIX.p1, description: "A jointless microcement ensuite in a warm off-white tone. A floating double vanity and brass tapware sit against seamless, tactile walls for a calm, spa-like feel." },
  { id: "grey-microcement-bathroom", title: "Grey Microcement Bathroom", category: "residential", finish: "Microcement", location: "Perth, WA", image: WIX.p3, description: "A soft grey microcement bathroom with an arched niche, wall-hung toilet and brushed-brass fittings — continuous, grout-free walls with a natural stone-like surface." },
  { id: "microcement-shower-niche", title: "Microcement Shower & Niche", category: "residential", finish: "Microcement + Waterproofing", location: "Perth, WA", image: WIX.p4, description: "A waterproofed walk-in shower wrapped in seamless microcement, with a recessed niche and ceiling-mounted brass shower for a completely grout-free wet area." },
  { id: "terracotta-plaster-staircase", title: "Terracotta Plaster Staircase", category: "residential", finish: "Polished Plaster", location: "Perth, WA", image: WIX.p5, description: "A warm terracotta polished-plaster wall wrapping a sculptural white staircase, with integrated floating shelves and a bright picture window." },
  { id: "polished-plaster-stairwell", title: "Polished Plaster Stairwell", category: "commercial", finish: "Polished Plaster", location: "Perth, WA", image: WIX.p6, description: "A satin polished-plaster finish lining a light-filled stairwell in a soft neutral tone, delivering a smooth, seamless surface across a large fit-out." },
  { id: "microcement-kitchen-island", title: "Microcement Kitchen Island", category: "residential", finish: "Microcement", location: "Perth, WA", image: WIX.p12, description: "A monolithic microcement kitchen island with an integrated sink — a seamless, concrete-look benchtop that anchors an open-plan kitchen." },
  { id: "bathroom-waterproofing-prep", title: "Bathroom Waterproofing & Prep", category: "residential", finish: "Waterproofing + Microcement", location: "Perth, WA", image: WIX.p7, description: "Behind every seamless finish: a fully waterproofed and prepared wet area, with niches and shelving set out before the microcement is hand-applied." },
  { id: "microcement-washroom", title: "Microcement Washroom", category: "residential", finish: "Microcement", location: "Perth, WA", image: WIX.p10, description: "A light-filled washroom finished in soft grey microcement, with a window niche and integrated bench for a calm, seamless look." },
];

// Shared specialisations grid (homepage + services overview). Rows 1 & 2, then Microcement featured.
export const SPECIALISATIONS = [
  { title: "Rendering", index: "01", tagline: "Refined. Resilient. Architectural.", image: "https://images.pexels.com/photos/13203194/pexels-photo-13203194.jpeg?auto=compress&cs=tinysrgb&w=1200", to: "/services/rendering", testid: "service-card-rendering" },
  { title: "Waterproofing", index: "02", tagline: "Protected. Guaranteed. Invisible.", image: "https://images.unsplash.com/photo-1744217725753-3fe4a7801645?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", to: "/services/waterproofing", testid: "service-card-waterproofing" },
  { title: "Plastering", index: "03", tagline: "Crafted. Luminous. Timeless.", image: WIX.p5, to: "/services/plastering", testid: "service-card-plastering" },
  { title: "Concrete Repairs", index: "04", tagline: "Restored. Reinforced. Resilient.", image: "https://images.pexels.com/photos/29152268/pexels-photo-29152268.jpeg?auto=compress&cs=tinysrgb&w=1200", to: "/services/remediation", testid: "service-card-concrete-repairs" },
  { title: "Rising Damp Treatment", index: "05", tagline: "Diagnosed. Treated. Protected.", image: "https://images.pexels.com/photos/14109699/pexels-photo-14109699.jpeg?auto=compress&cs=tinysrgb&w=1200", to: "/services/remediation", testid: "service-card-rising-damp" },
  { title: "Crack Injection", index: "06", tagline: "Sealed. Structural. Permanent.", image: "https://images.pexels.com/photos/7717787/pexels-photo-7717787.jpeg?auto=compress&cs=tinysrgb&w=1200", to: "/services/remediation", testid: "service-card-crack-injection" },
];

export const MICROCEMENT_FEATURED = {
  title: "Microcement",
  image: WIX.p1,
  to: "/services/microcement",
  desc: "A continuous, jointless surface system applied at 2–3mm. A refined finish for floors, walls, and wet areas.",
};
